<div [formGroup]="form">
    <div class="row">                                
        <div class="col-md-12 col-xs-12">
            <div class="row">
                <hr style="width: 98%">
            </div>
        </div>
        <div>
            <div class="row">
                <div class="controls-group-h">
                    <label class="form-radio-label">                           
                        <input type="checkbox" formControlName="declaration_check" >&nbsp;
                        <span class="checkmark"></span>הנני מצהיר/ה כי כל הפרטים נכונים ומדויקים ומתחייב/ת להשיב את כל הסיוע שיינתן לי על סמך פרטים אלו, אם יסתבר כי אין זה כך                               
                    </label>                                
                </div>
            </div>
        </div>
    </div>
    <div class="row" > 
        <div class="col-md-12 col-xs-12" *ngIf="showCaptcha">             
            <moia-captcha [isSubmitted]="isSubmitted" isFormValidation="true"></moia-captcha>    
        </div>       
    </div>
    <div class="row mt-10">                                
        <div class="col-md-12 col-xs-12">                              
            <div class="row">
                <div class="col-md-12 col-xs-12 text-ltr">
                    <label>
                        <button  class="btn btn-material raised btn big" [disabled]="f.declaration_check && !f.declaration_check.valid"
                            (click)="onSubmit()">
                            המשך
                        </button>                                                                   
                        <button type="button" class="btn big" (click)="onReset()">נקה טופס</button> 
                    </label>
                </div>
            </div>
            <br>
        </div>
    </div>        
</div>